import { Component } from '@angular/core';
import { E5coreUiWorkFieldTypeInputBaseComponent } from './e5core-ui-work-field-type-input-base';

@Component({
  selector: 'e5core-ui-work-field-type-input-box',
  templateUrl: './e5core-ui-work-field-type-input-box.component.html',
  styleUrls: ['./e5core-ui-work-field-type-input-box.component.css']
})
export class E5coreUiWorkFieldTypeInputBoxComponent extends E5coreUiWorkFieldTypeInputBaseComponent {
}

